<template>

    <edit-form
        :title="title"
        :subTitle="subTitle"
        :schema="schema"
        storeNamespace="settings"
        objectNamespace="O_queue"
        :objectId="id"
        :listOnSave="listOnSave"
    >

    </edit-form>

</template>

<script>
import EditForm from '@/components/form/EditForm'

export default {
    name: "QueueForm",
    components: {
        EditForm,
    },
    props: {
        id: {
            type: String
        },
        listOnSave: {
            type: Boolean,
            default: false 
        },
    },
    computed: {
       schema() {
            const filter = {
                name: '{ type:"input", rules:"required" }',
                type: '{ type:"select", rules:"required", items:["internal"] }',
                description: '{ type:"textarea", rules:"required" }',
                color: '{ type:"colorPicker", rules:"required" }'
            }
            
            return this.$helpers.schemaParser(filter)
        },
        title() {
            return this.id ? "Updatera kö" : "Ny kö";
        },
        subTitle() {
            return this.id ? "Här kan du uppdatera en kö" : "Här kan du skapa en ny kö";
        },
        
    },
}
</script>

<style>

</style>